import React, { useState } from "react";
import { StyledWriteNote } from "../Note.styled";
import TextArea from "../../../../../../components/core/TextArea/TextArea";
import { IconManager } from "../../../../../../components/core/IconManager/IconManager";
import { IconSizeEnum } from "../../../../../../types/AppTypes";
import { WRITE_A_NOTE_LABEL } from "../../../../../../constants/Dictionary";
import { CHARACTER_MAX_LENGTH } from "../../../../../../constants/AppConstants";
import { ReactComponent as ArrowUpIcon } from "../../../../../../icons/arrowUp.svg";
import { theme } from "../../../../../../constants/StyledComponents";

type NoteFooterProps = {
  setEdit: (value: boolean) => void;
  onSave: (text: string) => void;
};

export const NoteFooter = ({ setEdit, onSave }: NoteFooterProps) => {
  const [value, setValue] = useState("");

  const onChange = (text: string) => {
    setValue(text);
    setEdit(text !== "");
  };

  const handleSave = () => {
    onSave(value);
    setValue("");
    setEdit(false);
  };

  return (
    <StyledWriteNote>
      <TextArea
        label={WRITE_A_NOTE_LABEL}
        maxLength={CHARACTER_MAX_LENGTH}
        value={value}
        onChange={onChange}
      />
      <IconManager
        size={IconSizeEnum.MEDIUM}
        onClick={value ? handleSave : undefined}
        color={value ? theme.colors.black : theme.colors.grey_4}
      >
        <ArrowUpIcon />
      </IconManager>
    </StyledWriteNote>
  );
};
